/**
 * Fetches public subscription/display pricing (PBI #1193).
 * Cached by the API (ResponseCache 5 min) and optionally by the SPA hook.
 */

import apiClient from './apiClient';
import type { PublicSubscriptionConfig } from '../types/publicSubscriptionConfig';

interface PublicSubscriptionConfigApiDto {
  freeContactLimit: number;
  mailedCardListPriceUsd: number;
  mailedCardMemberPriceUsd: number;
  mailedCardMemberDiscountPercent: number;
  animatedCardListPriceUsd: number;
  animatedCardMemberPriceUsd: number;
  animatedCardMemberDiscountPercent: number;
}

/**
 * Loads free-contact limit and mailed/animated list+member display amounts.
 */
export async function getPublicSubscriptionConfig(): Promise<PublicSubscriptionConfig> {
  const { data } = await apiClient.get<PublicSubscriptionConfigApiDto>(
    '/public/subscription/config',
  );

  return {
    freeContactLimit: data.freeContactLimit,
    mailedCardListPriceUsd: data.mailedCardListPriceUsd,
    mailedCardMemberPriceUsd: data.mailedCardMemberPriceUsd,
    mailedCardMemberDiscountPercent: data.mailedCardMemberDiscountPercent,
    animatedCardListPriceUsd: data.animatedCardListPriceUsd,
    animatedCardMemberPriceUsd: data.animatedCardMemberPriceUsd,
    animatedCardMemberDiscountPercent: data.animatedCardMemberDiscountPercent,
  };
}
